import React, { Component } from "react";
import { Route } from "react-router";
import MainLayout from "./MainLayout";

interface Props {
  component: any;
  path?: string;
  exact?: boolean;
  contextLevel?: string;
}

export const MainLayoutRoute = (props: Props) => {
  const { component: Component, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(props) => (
        <MainLayout>
          <Component contextLevel={props.contextLevel} />
        </MainLayout>
      )}
    />
  );
};
